import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ReviewForm.css';
import moment from 'moment';

class FieldWorkOrderReview extends Component {
  static propTypes = {
    fieldWorkOrder: PropTypes.shape({}).isRequired,
  };

  render() {
    const { fieldWorkOrder } = this.props;
    return (
      <div className="review-form-trade-block review-form-field-work-order">
        <div className="review-form-title-bloc">
          <p className="review-form-block-title-fwo">
            <span>FIELD WORK ORDER</span>
          </p>
          <p className="review-form-block-field-fwo">
            {!!fieldWorkOrder.number && (
              <span>FWO#: {fieldWorkOrder.number}</span>
            )}
          </p>
          {((fieldWorkOrder.preset_tasks &&
            fieldWorkOrder.preset_tasks.length) ||
            fieldWorkOrder.preset_task_other) && (
            <div className="review-form-block-field-fwo">
              <p>Tasks to be performed:</p>
              {!!fieldWorkOrder.preset_tasks.length &&
                fieldWorkOrder.preset_tasks.map((task) => (
                  <p key={task.id}>• {task.label}</p>
                ))}
              {!!fieldWorkOrder.preset_task_other && (
                <p>• {fieldWorkOrder.preset_task_other}</p>
              )}
            </div>
          )}
          {!!fieldWorkOrder.work_performed && (
            <div className="review-form-block-field-fwo">
              <p>Work to be performed:</p>
              <p>{fieldWorkOrder.work_performed}</p>
            </div>
          )}
          {!!fieldWorkOrder.comments && (
            <div className="review-form-block-field-fwo">
              <p>Comments:</p>
              <p>{fieldWorkOrder.comments}</p>
            </div>
          )}
          <div className="review-form-block-field-fwo">
            <p>Start date:</p>
            {!!fieldWorkOrder.start_date ? (
              <p>{moment(fieldWorkOrder.start_date).format('MM/DD/YYYY')}</p>
            ) : (
              <p>TBD</p>
            )}
          </div>
          <div className="review-form-block-field-fwo">
            <p>Completion Date:</p>
            {!!fieldWorkOrder.completion_date ? (
              <p>
                {moment(fieldWorkOrder.completion_date).format('MM/DD/YYYY')}
              </p>
            ) : (
              <p>TBD</p>
            )}
          </div>
          {!!fieldWorkOrder.labor && (
            <div className="review-form-block-field-fwo">
              <p>Labor:</p>
              <p>{fieldWorkOrder.labor}</p>
            </div>
          )}
          {!!fieldWorkOrder.materials && (
            <div className="review-form-block-field-fwo">
              <p>Materials:</p>
              <p>{fieldWorkOrder.materials}</p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default FieldWorkOrderReview;



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-daily-report-log/FieldWorkOrderReview.js